import { Box } from '@mui/material';
import React from 'react';
import { flexGap2 } from '../../../../../constants/lkCadastr/cadastrStorage';
import { TextTitle } from '../../../../../components/Text';
import Submit from '../../../../../components/Buttons/SubmitButton';

export function DownloadButton({ onClick, disabled }) {
  return (
    <Box sx={flexGap2}>
      <TextTitle>&nbsp;</TextTitle>
      <Submit value="Скачать отчет" onClick={onClick} sx={{ height: '50px', width: '200px' }} disabled={disabled} />
    </Box>
  );
}
